import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { I18n } from 'core';

import Button from 'components/Button/Button';
import { navigate } from 'navigation';
import SectionWrapper from 'components/SectionWrapper/SectionWrapper';
import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import solicitudesPendientesNuevoOnboarding from 'services/remote/SolicitudesPendientesNuevoOnboarding';
// import { CommunitiesEnrolledListPaginator } from './components/communities-enrolled-list-paginator/communities-enrolled-list-paginator';

import { Spinner } from 'components';
import styles from './comunities-solicitudes-pendiente-list-page-new-onboarding.module.scss';
import { PendingRequestsTable } from './components/comunities-solicitudes-pendiente-list-page-new-onboarding-table/comunities-solicitudes-pendiente-list-page-new-onboarding-table';
import {
  FiltersUI,
  SolicitudesFilterBar,
} from '../comunities-solicitudes-general-list-page/components/SolicitudesFilterBar/SolicitudesFilterBar';

interface ParameterDetalles {
  communityID: string;
}

export const SolicitudesPendienteListPageNewOnboarding = (): JSX.Element => {
  const [solicitudPendiente, setSolicitudPendiente] = useState<SolicitudPendiente[]>([]);
  const { communityID } = useParams<ParameterDetalles>();

  const [loading, setLoading] = useState(false);

  const [filtersUI, setFiltersUI] = useState<FiltersUI>({
    status: 'pendientes',
    order: undefined,
    term: '',
  });
  const SORT_FIELD = 'fecha_creacion';

  const sortClient = (data: SolicitudPendiente[], order: FiltersUI['order']) => {
    const getTs = (r: any) => new Date(r?.[SORT_FIELD] ?? r?.created_at ?? r?.fecha_alta ?? 0).getTime();
    if (order === 'recientes') return [...data].sort((a, b) => getTs(b) - getTs(a));
    if (order === 'antiguas') return [...data].sort((a, b) => getTs(a) - getTs(b));
    return data; // sin orden explícito
  };
  const handleFiltersChange = (next: FiltersUI) => {
    setFiltersUI((prev) => {
      const statusChanged = next.status !== prev.status;
      // si el usuario toca el status, limpiamos el order
      if (statusChanged) {
        return { ...next, order: '' as FiltersUI['order'] };
      }
      return next;
    });
  };
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const fetchSolicitudes = async () => {
      const filters: any = {};
      filters.pendientes = true; // Assuming you want to fetch only pending requests
      try {
        let filter: any = {};
        if (filtersUI.term?.trim()) filter.search_param = filtersUI.term.trim();
        if (filtersUI.status === 'pendientes') {
          filter.pendientes = true;
        } else if (filtersUI.status === 'acabadas') {
          filter.acabadas = true;
        } else if (filtersUI.status === 'en curso') {
          filter.acabadas = false;
        } else if (filtersUI.status === 'todas') {
          filter = {};
        }
        filter.comunidad_id = communityID;
        const response = await solicitudesPendientesNuevoOnboarding.getPendingRegistrationRequests(filter);
        if (!cancelled) {
          const filtered = response.filter((item: SolicitudPendiente) => item.email && item.email.trim() !== '');
          const sorted = sortClient(filtered, filtersUI.order);
          setSolicitudPendiente(sorted);
        }
      } catch (err) {
        if (!cancelled) console.error('Error obteniendo solicitudes pendientes:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    const t = setTimeout(fetchSolicitudes, 300);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [filtersUI, communityID]);
  return (
    <div className={communityID !== undefined ? styles.container : styles.container2}>
      {communityID !== undefined ? null : (
        <div className={styles.header}>
          <Button
            className={styles.viewmore_button}
            variant="tertiary"
            type="button"
            onClick={(): Promise<void> => navigate('/tecnic/dashboard')}
            text={I18n.t('UsersPage.goDashboard')}
          />
        </div>
      )}
      <SectionWrapper>
        <SolicitudesFilterBar value={filtersUI} onChange={handleFiltersChange} disabled />
        <div className={styles.table_wrapper}>
          {loading ? (
            <div className={styles.loading}>
              <Spinner size={30} />
            </div>
          ) : (
            <PendingRequestsTable data={solicitudPendiente} communityID={communityID} />
          )}
        </div>
        <div>
          {/* <CommunitiesEnrolledListPaginator current={0} max={1} handleNext={() => {}} handlePrev={() => {}} /> */}
        </div>
      </SectionWrapper>
    </div>
  );
};
